export default "__VITE_ASSET__aef7cfbe__"